module.exports = __webpack_public_path__ + "img/credit_card.e6c6a1aa.svg";